// ----------------------------------------------------------------------

export default function ToolTip(theme) {
    return {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    padding: 4,
                },
            },
        },
    };
}
